import React from "react";
import { Input, Form } from "antd";

export default function airForm(Component) {
  return class extends React.Component {
    requiredRule = label => {
      return {
        required: true,
        message: `[${label}] is required`
      };
    };

    WithDecorator = (name, label, fieldDecoratorOptions, formItemLayout) => component => {
      return (
        <Form.Item label={label} colon={false} {...formItemLayout} className={`form-item-${name}`}>
          {fieldDecoratorOptions
            ? this.props.form.getFieldDecorator(name, fieldDecoratorOptions)(component)
            : component}
        </Form.Item>
      );
    };

    RequiredWithDecorator = (name, label, fieldDecoratorOptions = {}, formItemLayout) => component => {
      fieldDecoratorOptions.rules = [this.requiredRule(label), ...(fieldDecoratorOptions.rules || [])];
      return this.WithDecorator(name, label, fieldDecoratorOptions, formItemLayout)(component);
    };

    BasicInputField = (name, label, { onChange, placeholder, type, disabled, rules = [] }, formItemLayout) =>
      this.WithDecorator(
        name,
        label,
        {
          rules: [...rules]
        },
        formItemLayout
      )(
        <Input
          type={type || "text"}
          placeholder={placeholder || label}
          onChange={onChange}
          disabled={disabled}
          name={name}
        />
      );

    render() {
      this.props = Object.assign({}, this.props, {
        BasicInputField: this.BasicInputField,
        WithDecorator: this.WithDecorator,
        requiredRule: this.requiredRule,
        RequiredWithDecorator: this.RequiredWithDecorator
      });
      return <Component {...this.props} />;
    }
  };
}



// WEBPACK FOOTER //
// ./src/commonComponents/AirForm.js